

export function pushDataLayer(data){
    const dataLayer = window.dataLayer || [];

    dataLayer.push(data);
}